import axios from "axios";
import { useToast } from "vue-toastification";

const toast = useToast();

axios.interceptors.response.use(
  function (response) {
    // success message
    if (response.data.message !== undefined) {
      toast.success(response.data.message);
    }
    // Do something before request is sent
    return response;
  },
  function (error) {
    // error message
    let message = "Pri spracovávaní nastala chyba";

    if (error.response && error.response.data) {
      message = error.response.data.message;
    } else if (typeof error === "string") {
      message = error;
    }

    toast.error(message);
    // Do something with request error
    return Promise.reject(error);
  }
);

export default axios;
